// import axios from 'axios';
import { createApiCSRFClient } from './interceptors.js';

const API_DOMAIN = process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND; // 本機區網開發{ip}
// const API_DOMAIN = process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:8000'; # 上線打包
// const API_DOMAIN = process.env.NODE_ENV === 'production' ? '' : ' https://7310-61-61-147-102.ngrok.io';
// console.log('API_DOMAIN', API_DOMAIN);

/* 呼叫POST的方法 */

// POST 獲取 JWT Token
const authJwtToken = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/api/`,
  withCredentials: true,
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
});

// POST 新會員註冊資訊
const registerMember = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/`,
  withCredentials: true,
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
});

// POST 新Django Super會員
const registerDjangoSuperMember = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/`,
  withCredentials: true,
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
});

// POST 新會員 故事卡
const createUserResume = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume_outline`,
  withCredentials: true,
});

// POST 新提問
const createNewQuestion = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/new_post`,
  withCredentials: true,
  // headers: { 'content-type': 'application/x-www-form-urlencoded' },
  // withCredentials: true,
});

/* 呼叫GET的方法 */

// GET最新標籤列表
const latestTags = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchtype_data`,
  withCredentials: true,
});

// GET最新標籤列表
const latestTeamFeature = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/npo/feature_listname`,
  withCredentials: true,
});

// GET 全部會員登入
const djangoAllTypeMember = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchSuper`,
  withCredentials: true,
});

// PUT 全部會員登入
const checkAllAuthMember = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/checkAuth`,
  withCredentials: true,
});

// PUT 全部會員登入
const checkAuthMemberFindPassword = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/checkAuthFindPassword`,
  withCredentials: true,
});

// GET 醫生會員登入
const doctorMemberData = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchdoctor_data`,
  withCredentials: true,
});

// GET 一般會員登入
const normalMemberData = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchuser_data`,
  withCredentials: true,
});

// GET 登入者醫生會員資料
const uniqueDoctorData = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/doct_profile`,
  withCredentials: true,
});

// GET 登入者一般會員資料
const uniqueNormalData = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/user_profile`,
  withCredentials: true,
});

// GET 登入
const userLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/login`,
  withCredentials: true,
});

// GET 自動登入
const userAutoLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/auto_login`,
  withCredentials: true,
});

// GET 獲取首頁流程標籤
const flowArticleTagList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/flowarticle_list`,
  withCredentials: true,
});

// GET跟Filter爬蟲文章
const crawlArticles = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searcharticles`,
  withCredentials: true,
});

// GET跟Filter爬蟲文章
const crawlAllFlowArticles = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searcharticle/merge`,
  withCredentials: true,
});

// GET跟Filter獨家專欄
// const crawlAllFlowScoop = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/searchscoop/merge`,
//   withCredentials: true,
// });

// GET跟Filter團隊組織
const searchNpoResult = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/search/npo`,
  withCredentials: true,
});

// GET跟Filter爬蟲文章
// const crawlAllFlowResume = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/searchresume/merge`,
//   withCredentials: true,
// });

// GET跟Filter故事卡資料
const crawlFlowResumeDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchresume/detail`,
  withCredentials: true,
});

// GET討論板清單
// const crawlAllFlowQa = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/searchqa/merge`,
//   withCredentials: true,
// });

// GET保持登入驗證Session並獲得登入者資料
const checkSessionKeepLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/session_read?format=json`,
  withCredentials: true,
});

// GET 刪除保持登入驗證Session並清除登入者Session資料
const cleanSessionKeepLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/remove_session/`,
  withCredentials: true,
});

// GET 首頁Banner區資訊
const getIndexBannerState = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/randomBanner`,
  withCredentials: true,
});

// GET SearchBar 搜尋結果
const getSearchBar = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchbar/`,
  withCredentials: true,
});

// GET Ai SearchBar 搜尋結果
const putAiSearchBar = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchbar/split`,
  withCredentials: true,
});

// GET SearchBar 文章的 推薦解說
const getSearchBarOverview = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/searchoverview/`,
  withCredentials: true,
});

// GET 產生Qrcode圖像
const getGenerateQrcode = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qrcode/`,
  withCredentials: true,
});

// GET Server當前時間
const getCurrentDateNow = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/get_time`,
  withCredentials: true,
});

// 發送 信箱驗證信
const sendVerifiedConfirm = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/send_verify_mail`,
  withCredentials: true,
});

// 取得故事卡資訊
const loadMemberResume = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume_load`,
  withCredentials: true,
});

// 上傳大頭貼
const userAvatarHistory = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/avatar_history`,
  withCredentials: true,
});

/* 呼叫PUT的方法 */

// PUT 讀取所有分類收藏
// const userAllBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/all/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// PUT 登入者新增 加入收藏
const userAddBookmark = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/article/addbookmark`,
  withCredentials: true,
});

// GET 讀取收藏的文章列表
// const userLoadArticleBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/article/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// GET 讀取收藏的專欄列表
// const userLoadScoopBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// PUT 登入者新增 故事卡加入收藏
const userResumeBookmark = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/addbookmark`,
  withCredentials: true,
});

// PUT 登入者新增 討論板加入收藏
const userQaBookmark = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/addbookmark`,
  withCredentials: true,
});

// PUT 登入者新增 獨家專欄加入收藏
// const userScoopBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/addbookmark`,
//   withCredentials: true,
// });

// PUT 登入者新增 廠商機構加入收藏
// const userTeamBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/npo/addbookmark`,
//   withCredentials: true,
// });

// GET 讀取收藏的故事卡列表
// const userLoadResumeBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/resume/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// GET 讀取收藏的討論板列表
// const userLoadQaBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/qa/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// PUT 登入者新增 加入收藏
const userDrugBookmark = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/drug/addbookmark`,
  withCredentials: true,
});

// GET 讀取收藏的藥品列表
// const userLoadDrugBookmark = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/drug/addbookmark_load`,
//   withCredentials: true,
//   headers: { 'content-Type': 'application/json' },
// });

// PUT 登入者新增 點推薦
const userAgree = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/article/agree`,
  withCredentials: true,
});

// GET 讀取文章所有點推薦者
const userLoadAgree = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/article/agree_load`,
  withCredentials: true,
});

// POST 登入者新增 故事卡點推薦
const userResumeAgree = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/agree`,
  withCredentials: true,
});

// POST 登入者新增 討論板點推薦
const userQaAgree = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/agree`,
  withCredentials: true,
});

// POST 登入者新增 獨家專欄點推薦
// const userScoopAgree = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/agree`,
//   withCredentials: true,
// });

// GET 讀取故事卡所有點推薦者
const userLoadResumeAgree = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/agree_load`,
  withCredentials: true,
});

// PUT 登入者新增 點讚
const userLike = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/article/like`,
  withCredentials: true,
});

// GET 讀取文章所有點讚者
const userLoadLike = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/article/like_load`,
  withCredentials: true,
});

// POST 登入者新增 故事卡點讚
const userResumeLike = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/like`,
  withCredentials: true,
});

// POST 登入者新增 討論板點讚
const userQaLike = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/like`,
  withCredentials: true,
});

// POST 登入者新增 獨家專欄點讚
// const userScoopLike = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/like`,
//   withCredentials: true,
// });

// GET 讀取文章所有點讚者
const userLoadResumeLike = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/like_load`,
  withCredentials: true,
});

// PUT 加入追蹤醫師
const userFollow = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/follow`,
  withCredentials: true,
});

// GET 讀取所有追蹤者與被追蹤者列表
const userLoadFollow = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/follow_load`,
  withCredentials: true,
});

// PUT 更新故事卡狀態
const resumeStatus = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_status`,
  withCredentials: true,
});

// PUT 更新故事卡 Flow01
const resumeDetect = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_detect`,
  withCredentials: true,
});

// PUT 更新故事卡 Flow02
const resumeDiagnose = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_diagnose`,
  withCredentials: true,
});

// PUT 更新故事卡 Flow03
const resumeCure = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_cure`,
  withCredentials: true,
});

// PUT 更新故事卡 Flow03 藥品
const resumeCureDrug = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_drug`,
  withCredentials: true,
});

// PUT 更新故事卡 Flow04
const resumeNewlife = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume/update_newlife`,
  withCredentials: true,
});

// PUT 積分排行榜
const rankList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/rank_list`,
  withCredentials: true,
});

// PUT 更新提問狀態
const questionStatus = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/update_post`,
  withCredentials: true,
});

// PUT 取得隨機故事卡
const randomResume = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume_load_random`,
  withCredentials: true,
});

// 控制暖心祝福
const controlBless = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/resume_bless`,
  withCredentials: true,
});

// 上傳大頭貼
const userAvatarUpload = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/avatar_upload`,
  withCredentials: true,
});

// 線上諮詢上傳圖片
const effectChatUpload = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat_image_save/`,
  withCredentials: true,
});

// 同意Cookie
const userAllowCookie = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/accept_cookie/`,
  withCredentials: true,
});

const showAgreeList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/agree_doctlist/`,
  withCredentials: true,
});

const showQaReplyList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/qa_reply`,
  withCredentials: true,
});

const createQaReply = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/new_reply`,
  withCredentials: true,
});

const showUserQaAsk = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/user_ask_list`,
  withCredentials: true,
});

const showUserQaReply = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/user_reply_list`,
  withCredentials: true,
});

const deleteQaReply = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/delete_reply`,
  withCredentials: true,
});

const deleteQaAsk = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/delete_post`,
  withCredentials: true,
});

const showQaSubReplyList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/qa_inner_reply`,
  withCredentials: true,
});

const getQaStatus = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/qa/qa_load`,
  withCredentials: true,
});

// POST 新檢舉
const createNewReport = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/report/new_issue`,
  withCredentials: true,
});

// POST 新通知
const controlNewNotify = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/notify/add_event`,
  withCredentials: true,
});

// PUT 更新通知已讀取
const updateNotifyRead = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/notify/update_event`,
  withCredentials: true,
});

// DELETE 清除通知已讀取
const clearAllNotifyRead = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/notify/clear_event`,
  withCredentials: true,
});

// PUT 累積經驗值
const addUserScore = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/digital/add_number`,
  withCredentials: true,
});

// PUT 累積C幣
const addUserPoint = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/game/add_point`,
  withCredentials: true,
});

const loadUserScore = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/digital/user_score`,
  withCredentials: true,
});

// const loadScoopStatus = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/load_status`,
//   withCredentials: true,
// });

// const loadScoopContent = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/load_content`,
//   withCredentials: true,
// });

// const loadScoopOrigin = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/load_origin`,
//   withCredentials: true,
// });

// const loadScoopRelative = createApiCSRFClient({
//   baseURL: `${API_DOMAIN}/apiserver/scoop/load_relative`,
//   withCredentials: true,
// });

// GET Team廠商資訊
const loadNpoProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/npo/load_profile`,
  withCredentials: true,
});

// PUT Team廠商綁定資訊
const loadVendorBindProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/vendor/bind_profile`,
  withCredentials: true,
});

// PUT Team廠商資訊
const loadVendorProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/vendor/profile`,
  withCredentials: true,
});

// POST PUT 副作用基本資料
const updateSideEffectProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/profile/edit`,
  withCredentials: true,
});

const createSideEffectRecordBasic = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/create/basic`,
  withCredentials: true,
});

const createSideEffectRecordCore = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/create/core`,
  withCredentials: true,
});

const eproFormJoinCheck = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/form/join_check`,
  withCredentials: true,
});

const eproFormJoinControl = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/form/join_control`,
  withCredentials: true,
});

// PUT 副作用一般記錄
const killSideEffectRecord = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/detail/delete`,
  withCredentials: true,
});

// GET 副作用記錄
const loadSideEffectList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/detail/list`,
  withCredentials: true,
});

// GET 副作用病歷資料
const loadSideEffectProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/profile/load`,
  withCredentials: true,
});

// GET 副作用紀錄資料
const loadSideEffectRecordDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/detail/load`,
  withCredentials: true,
  // withCredentials: true,
});

// PUT EPRO表單列表
const loadEproFormList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/form/list`,
  withCredentials: true,
});

// PUT EPRO表單細節內容
const loadEproFormDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/form/detail`,
  withCredentials: true,
});

const checkEproRecordDate = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/epro/form/date_check`,
  withCredentials: true,
});

// GET 商城資料
const loadShopMallSubscribe = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/shopmall/subscribe/load`,
  withCredentials: true,
});

const loadShopMallBusiness = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/shopmall/business/load`,
  withCredentials: true,
});

// 訂閱組合單品資訊
const loadShopMallBundleDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/shopmall/bundle/detail`,
  withCredentials: true,
});

const ecpaySendPayment = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/ecpay_record_backend/`,
  withCredentials: true,
});

const ecpayUserOrderList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/pay_find_merchandise_list`,
  withCredentials: true,
});

const convertUserOrderList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/coin_find_merchandise_list`,
  withCredentials: true,
});

const ecpayUserReturnOrder = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/ecpay_return_merchandise`,
  withCredentials: true,
});

const linePayHandlePayment = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/line_pay`,
  withCredentials: true,
});

const aiDoctorSearch = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/aidoctor/search`,
  withCredentials: true,
});

const aiDoctorPopular = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/aidoctor/popular`,
  withCredentials: true,
});

const crawlContentByLink = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/crawl_url/`,
  withCredentials: true,
});

const checkUserSubscribeList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/user_subscribe_check`,
  withCredentials: true,
});

const sendEvaluate = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/aidoctor/evaluate`,
  withCredentials: true,
});

const downloadEffectRecord = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/detail/generate_pdf`,
  withCredentials: true,
});

const chatHistoryList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/record_list`,
  withCredentials: true,
});

const chatConsultRoomList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/consult_room_list`,
  withCredentials: true,
});

const chatUpdateRoomRead = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/update_room_read`,
  withCredentials: true,
});

const chatUserRead = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/update_message_read`,
  withCredentials: true,
});

const sendUserFeedback = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/send_feedback`,
  withCredentials: true,
});

const sendUserFeedbackThread = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/send_feedback_thread`,
  withCredentials: true,
});

const chatRoomCreate = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/create_room`,
  withCredentials: true,
});

const chatRoomRecordDownload = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/record_download`,
  withCredentials: true,
});

const webPushSaveSubscribe = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/save_webpushinfo`,
  withCredentials: true,
});

const webPushSendNotification = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/send_push`,
  withCredentials: true,
});

const coinFreeConvert = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/shopmall/convert`,
  withCredentials: true,
});

const redeemConvert = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/redeem/convert`,
  withCredentials: true,
});

// POST Dr.Cell 翻譯
const reportTranslator = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/translation`,
  withCredentials: true,
});

// POST Dr.Cell 上傳圖片翻譯
const reportUploadTranslator = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/photo_translation`,
  withCredentials: true,
});

// 保存 Dr.Cell 翻譯結果
const saveTranslatorResult = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/update_translation`,
  withCredentials: true,
});

// 讀取 Dr.Cell 翻譯結果列表
const loadTranslatorResult = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/load_translation`,
  withCredentials: true,
});

// 建立新的飲食辨識分析
const dietRecognize = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/diet_recognize`,
  withCredentials: true,
});

// 讀取 Dr.Cell 飲食辨識分析結果列表
const loadDietRecognize = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/load_recognize`,
  withCredentials: true,
});

// POST Dr.Cell 發問小幫手
const chatWizard = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/chat_wizard`,
  withCredentials: true,
});

// 建立新的飲食辨識分析
const glucosePressureRecognize = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/glucose_pressure_recognize`,
  withCredentials: true,
});

const loadSideEffectAmount = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/amount`,
  withCredentials: true,
});

const loadSideEffectCharts = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/charts`,
  withCredentials: true,
});

const loadGoldKnowLedge = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/gold_knowledge`,
  withCredentials: true,
});

const userEditAccountProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/auth_edit_account`,
  withCredentials: true,
});

const lineFastAuthorize = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/line_login/fast_oauth`,
  withCredentials: true,
});

const lineFastLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/line_login/fast_register`,
  withCredentials: true,
  // headers: { 'content-type': 'application/x-www-form-urlencoded' },
});

const lineKeepAutoLogin = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/line_login/auto_login`,
  withCredentials: true,
});

const vendorBindTrail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/vendor/bind_trail`,
  withCredentials: true,
});

const vendorBindCheck = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/vendor/bind_check`,
  withCredentials: true,
});

const courseList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/list`,
  withCredentials: true,
});

const courseDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/detail`,
  withCredentials: true,
});

const courseLoadUnitContent = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/unit_detail`,
  withCredentials: true,
});

const courseLoadEvaluate = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/evaluate_list`,
  withCredentials: true,
});

const courseControlEvaluate = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/evaluate_control`,
  withCredentials: true,
});

const courseUserEvaluateDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/course/evaluate_user_detail`,
  withCredentials: true,
});

const receiveTrailSubscribe = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/trail/free_subscribe`,
  withCredentials: true,
});

// 更新會員已讀最新消息
const userUpdateNewsRead = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/news/update`,
  withCredentials: true,
});

const userLoadLatestNews = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/news/load_list`,
  withCredentials: true,
});

const userLoadAnalysis = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/analysis/list`,
  withCredentials: true,
});

const userEvaluateAnalysis = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/sideeffect/analysis/evaluate`,
  withCredentials: true,
});

const userChatAiConsultation = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/drcell/chat_consultation`,
  withCredentials: true,
});

const chatUpdateHistoryList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/update_record_list`,
  withCredentials: true,
});

const lectureList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/lecture/list`,
  withCredentials: true,
});

const lectureDetail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/lecture/detail`,
  withCredentials: true,
});

const redeemValidCheck = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/redeem/valid_check`,
  withCredentials: true,
});

const loadUserFeedback = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/load_feedback`,
  withCredentials: true,
});

const assignVendorReply = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chat/assign_vendor_reply`,
  withCredentials: true,
});

const lineOfficialBundle = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/line_login/official_bundle`,
  withCredentials: true,
});

const healthCheckStatus = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/health_checklist/status`,
  withCredentials: true,
});

const healthCheckProfile = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/health_checklist/profile`,
  withCredentials: true,
});

const healthCheckAchieve = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/health_checklist/achieve`,
  withCredentials: true,
});

const unsubscribeMail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/unsubscribe_mail`,
  withCredentials: true,
});

const chatMessageLineNotification = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/linebot/chat_notification`,
  withCredentials: true,
});

const chronicBloodList = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/chronic/blood/list`,
  withCredentials: true,
});

const businessRequestMail = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/send_business_request_mail`,
  withCredentials: true,
});

const resetPasswordRequest = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/reset_password/request`,
  withCredentials: true,
});

const resetPasswordConfirm = createApiCSRFClient({
  baseURL: `${API_DOMAIN}/apiserver/reset_password/confirm`,
  withCredentials: true,
});

// POST Methods
export const postJwtToken = (path, data) => authJwtToken.post(path, data);
export const postRegisterMember = (path, data) => registerMember.post(path, data);
export const postDjangoSuperMember = (path, data) => registerDjangoSuperMember.post(path, data);
export const postUserNewResume = (path, data, config) => createUserResume.post(path, data, config);
export const postSendResumeAgree = (path, updateData, config) => userResumeAgree.post(path, updateData, config);
export const postSendResumeLike = (path, updateData, config) => userResumeLike.post(path, updateData, config);
export const postSendQaAgree = (path, updateData, config) => userQaAgree.post(path, updateData, config);
// export const postSendScoopAgree = (path, updateData, config) => userScoopAgree.post(path, updateData, config);
export const postSendQaLike = (path, updateData, config) => userQaLike.post(path, updateData, config);
// export const postSendScoopLike = (path, updateData, config) => userScoopLike.post(path, updateData, config);
export const postAddFollow = (path, updateData, config) => userFollow.post(path, updateData, config);
export const postSendAgree = (path, updateData, config) => userAgree.post(path, updateData, config);
export const postSendLike = (path, updateData, config) => userLike.post(path, updateData, config);
export const postAddResumeBookmark = (path, updateData, config) => userResumeBookmark.post(path, updateData, config);
export const postAddQaBookmark = (path, updateData, config) => userQaBookmark.post(path, updateData, config);
// export const postAddScoopBookmark = (path, updateData, config) => userScoopBookmark.post(path, updateData, config);
// export const postAddTeamBookmark = (path, updateData, config) => userTeamBookmark.post(path, updateData, config);
export const postAddBookmark = (path, updateData, config) => userAddBookmark.post(path, updateData, config);
export const postAddDrugBookmark = (path, updateData, config) => userDrugBookmark.post(path, updateData, config);
export const postResumeCureDrug = (path, updateData, config) => resumeCureDrug.post(path, updateData, config);
export const postCreateBless = (path, updateData, config) => controlBless.post(path, updateData, config);
export const postCreateQuestion = (path, updateData, config) => createNewQuestion.post(path, updateData, config);
export const postCreateQaReply = (path, updateData, config) => createQaReply.post(path, updateData, config);
export const postCreateNewReport = (path, data) => createNewReport.post(path, data);
export const postCreateNewNotify = (path, data) => controlNewNotify.post(path, data);
export const postCreateRecordBasic = (path, updateData, config) => createSideEffectRecordBasic.post(path, updateData, config);
export const postCreateRecordCore = (path, updateData, config) => createSideEffectRecordCore.post(path, updateData, config);
// export const postCreateSideEffectEvent = (path, updateData, config) => createSideEffectEvent.post(path, updateData, config);
// export const postCreateSideEffectCmuRecord = (path, updateData, config) => createSideEffectCmuRecord.post(path, updateData, config);
export const postEffectChatUpload = (path, updateData, config) => effectChatUpload.post(path, updateData, config);
export const postSendUserFeedback = (path, updateData, config) => sendUserFeedback.post(path, updateData, config);
export const postSendUserFeedbackThread = (path, updateData, config) => sendUserFeedbackThread.post(path, updateData, config);
export const postWpSaveSubscribe = (path, updateData, config) => webPushSaveSubscribe.post(path, updateData, config);
export const postWpSendNotification = (path, updateData, config) => webPushSendNotification.post(path, updateData, config);
// export const postOneSignalSaveSubscribe = (path, updateData, config) => oneSignalSaveSubscribe.post(path, updateData, config);
export const postReportTranslator = (path, updateData, config) => reportTranslator.post(path, updateData, config);
export const postReportUploadTranslator = (path, updateData, config) => reportUploadTranslator.post(path, updateData, config);
export const postLineFastAuthorize = (path, updateData, config) => lineFastAuthorize.post(path, updateData, config);
export const postVendorBindTrail = (path, updateData, config) => vendorBindTrail.post(path, updateData, config);
export const postCourseEvaluate = (path, updateData, config) => courseControlEvaluate.post(path, updateData, config);
export const postAiConsultation = (path, updateData, config) => userChatAiConsultation.post(path, updateData, config);
export const postAssignVendorReply = (path, updateData, config) => assignVendorReply.post(path, updateData, config);
export const postEproFormJoin = (path, updateData, config) => eproFormJoinControl.post(path, updateData, config);
export const postDietRecognize = (path, updateData, config) => dietRecognize.post(path, updateData, config);
export const postGlucosePressureRecognize = (path, updateData, config) => glucosePressureRecognize.post(path, updateData, config);
export const postChatWizard = (path, updateData, config) => chatWizard.post(path, updateData, config);
export const postHealthCheckAchieve = (path, updateData, config) => healthCheckAchieve.post(path, updateData, config);
export const postChatMessageLineNotification = (path, updateData, config) => chatMessageLineNotification.post(path, updateData, config);
export const postBusinessRequestMail = (path, updateData, config) => businessRequestMail.post(path, updateData, config);
export const postChatUserRead = (path, updateData, config) => chatUserRead.post(path, updateData, config);
export const postUniqueDoctor = (path, updateData, config) => uniqueDoctorData.post(path, updateData, config);
export const postUniqueNormal = (path, updateData, config) => uniqueNormalData.post(path, updateData, config);
export const postUserLogin = (path, updateData, config) => userLogin.post(path, updateData, config);
export const postUserAutoLogin = (path, updateData, config) => userAutoLogin.post(path, updateData, config);
export const postResetPasswordRequest = (path, updateData, config) => resetPasswordRequest.post(path, updateData, config);
export const postResetPasswordConfirm = (path, updateData, config) => resetPasswordConfirm.post(path, updateData, config);

// GET Methods
export const getLatestAllTags = (path) => latestTags.get(path);
export const getLatestAllTeamFeature = (path) => latestTeamFeature.get(path);
export const getDjangoAllTypeMember = (path) => djangoAllTypeMember.get(path);
export const getDoctorData = (path, authConfig) => doctorMemberData.get(path, authConfig);
export const getNormalData = (path, authConfig) => normalMemberData.get(path, authConfig);
// export const getUserIsRead = (path) => userUpdateNewsRead.get(path);
// 基本獲取文章api
export const getCrawlArticles = (path) => crawlArticles.get(path);
// 指定4大流程獲取文章api
// export const getCrawlFlowArticlesByLastest = (path) => crawlFlowArticles.get(path);
// export const getCrawlFlowArticlesByQuality = (path, config) => crawlFlowArticles.put(path, config);
export const getAllArticleByMerge = (path, config) => crawlAllFlowArticles.put(path, config);

// export const getCrawlFlowResume = (path, config) => crawlFlowResume.put(path, config);
// export const getAllResumeByMerge = (path, config) => crawlAllFlowResume.put(path, config);
// export const getAllScoopByMerge = (path, config) => crawlAllFlowScoop.put(path, config);
export const getSearchNpoResult = (path, updateData, config) => searchNpoResult.put(path, updateData, config);
// export const getAllQaByMerge = (path, config) => crawlAllFlowQa.put(path, config);

export const getCrawlFlowResumeDetail = (path) => crawlFlowResumeDetail.get(path);
export const getFlowArticleTags = (path) => flowArticleTagList.get(path);

export const getSessionKeepLogin = (path) => checkSessionKeepLogin.get(path);
export const getIndexRandomBanner = (path) => getIndexBannerState.get(path);
export const getSearchResults = (path) => getSearchBar.get(path);
export const getSearchOverview = (path) => getSearchBarOverview.get(path);
export const getImageQrcode = (path) => getGenerateQrcode.get(path);
export const getAvatarHistory = (path, config) => userAvatarHistory.put(path, config);
export const getMemberResume = (path, config) => loadMemberResume.put(path, config);
// export const getLoadAllBookmark = (path, updateData) => userAllBookmark.put(path, updateData);
// export const getLoadArticleBookmark = (path, updateData) => userLoadArticleBookmark.put(path, updateData);
// export const getLoadQaBookmark = (path, updateData) => userLoadQaBookmark.put(path, updateData);
// export const getLoadScoopBookmark = (path, updateData) => userLoadScoopBookmark.put(path, updateData);
// export const getLoadResumeBookmark = (path, updateData) => userLoadResumeBookmark.put(path, updateData);
// export const getLoadDrugBookmark = (path, updateData) => userLoadDrugBookmark.put(path, updateData);
export const getLoadSendAgree = (path, updateData, config) => userLoadAgree.put(path, updateData, config);
export const getLoadResumeSendAgree = (path, updateData, config) => userLoadResumeAgree.put(path, updateData, config);
export const getLoadSendLike = (path, updateData, config) => userLoadLike.put(path, updateData, config);
export const getLoadResumeSendLike = (path, updateData, config) => userLoadResumeLike.put(path, updateData, config);
export const getLoadAddFollow = (path, updateData, config) => userLoadFollow.put(path, updateData, config);
export const getRandomResume = (path, config) => randomResume.put(path, config);
// export const getSendUserPassWord = (path, config) => sendUserPassWord.put(path, config);
export const getAgreeDoctorList = (path, config) => showAgreeList.put(path, config);
export const getResumeBless = (path, config) => controlBless.put(path, config);
export const getCurrentDate = (path) => getCurrentDateNow.get(path);
export const getQaLoadStatus = (path) => getQaStatus.get(path);
export const getUserQaReplyList = (path) => showUserQaReply.get(path);
// export const getUserNotifyList = (path) => showNotifyList.put(path);
export const getUserScore = (path, config) => loadUserScore.put(path, config);
// export const getLoadScoopStatus = (path, updateData, config) => loadScoopStatus.put(path, updateData, config);
// export const getLoadScoopContent = (path) => loadScoopContent.get(path);
// export const getLoadScoopOrigin = (path) => loadScoopOrigin.get(path);
// export const getLoadScoopRelative = (path) => loadScoopRelative.get(path);
export const getLoadNpoProfile = (path) => loadNpoProfile.get(path);
export const getLoadSideEffectList = (path, updateData, config) => loadSideEffectList.put(path, updateData, config);
export const getLoadSideEffectProfile = (path, config) => loadSideEffectProfile.put(path, config);
export const getLoadSideEffectRecordDetail = (path, updateData, config) => loadSideEffectRecordDetail.put(path, updateData, config);
// export const getLoadShopMallStuff = (path, updateData, config) => loadShopMallStuff.put(path, updateData, config);
// export const getLoadShopMallBundle = (path, updateData, config) => loadShopMallBundle.put(path, updateData, config);
export const getLoadShopMallSubscribe = (path, updateData, config) => loadShopMallSubscribe.put(path, updateData, config);
export const getLoadShopMallBusiness = (path, updateData, config) => loadShopMallBusiness.put(path, updateData, config);
// export const getEcpayRedirection = (path) => ecpayRedirectLocation.get(path);
export const getEcpayUserOrderList = (path, config) => ecpayUserOrderList.put(path, config);
export const getConvertUserOrderList = (path, config) => convertUserOrderList.put(path, config);
export const getCrawlContentByLink = (path) => crawlContentByLink.get(path);
export const getDownloadEffectRecord = (path, config) => downloadEffectRecord.get(path, config);
// export const getDownloadEffectProfile = (path) => DownloadEffectProfile.get(path);
// export const getLoadShopStuffDetail = (path, updateData, config) => loadShopMallStuffDetail.put(path, updateData, config);
export const getLoadShopBundleDetail = (path, updateData, config) => loadShopMallBundleDetail.put(path, updateData, config);

// PUT Methods
export const putUniqueDoctor = (path, updateData) => uniqueDoctorData.put(path, updateData);
export const putUniqueNormal = (path, updateData) => uniqueNormalData.put(path, updateData);
export const putAvatarUpload = (path, updateData, config) => userAvatarUpload.put(path, updateData, config);
export const putResumeStatus = (path, updateData, config) => resumeStatus.put(path, updateData, config);
export const putResumeDetect = (path, updateData, config) => resumeDetect.put(path, updateData, config);
export const putResumeDiagnose = (path, updateData, config) => resumeDiagnose.put(path, updateData, config);
export const putResumeCure = (path, updateData, config) => resumeCure.put(path, updateData, config);
export const putResumeCureDrug = (path, updateData, config) => resumeCureDrug.put(path, updateData, config);
export const putResumeNewlife = (path, updateData, config) => resumeNewlife.put(path, updateData, config);
export const putQaStatus = (path, updateData, config) => questionStatus.put(path, updateData, config);
export const putRankList = (path, updateData, config) => rankList.put(path, updateData, config);
export const putAllowCookie = (path) => userAllowCookie.get(path);
export const putQaReplyList = (path, config) => showQaReplyList.put(path, config);
export const putQaSubReplyList = (path, config) => showQaSubReplyList.put(path, config);
export const putUserQaAskList = (path, config) => showUserQaAsk.put(path, config);
export const putUserNotifyRead = (path, config) => updateNotifyRead.put(path, config);
export const putAddUserScore = (path, updateData, config) => addUserScore.put(path, updateData, config);
export const putAddUserPoint = (path, updateData, config) => addUserPoint.put(path, updateData, config);
export const putUpdateSideEffectProfile = (path, updateData, config) => updateSideEffectProfile.put(path, updateData, config);
// export const putUpdateSideEffectRecord = (path, updateData, config) => updateSideEffectRecord.put(path, updateData, config);
// export const putUpdateSideEffectCmuRecord = (path, updateData, config) => updateSideEffectCmuRecord.put(path, updateData, config);
// export const putUpdateSideEffectEvent = (path, updateData, config) => updateSideEffectEvent.put(path, updateData, config);
export const putEcpaySendPayment = (path, updateData, config) => ecpaySendPayment.put(path, updateData, config);
export const putEcpayUserReturnOrder = (path, updateData, config) => ecpayUserReturnOrder.put(path, updateData, config);
export const putAiDoctorSearch = (path, updateData, config) => aiDoctorSearch.put(path, updateData, config);
export const putAiDoctorPopular = (path, updateData, config) => aiDoctorPopular.put(path, updateData, config);
export const putCheckUserSubscribe = (path, config) => checkUserSubscribeList.put(path, config);
export const putSendEvaluate = (path, updateData, config) => sendEvaluate.put(path, updateData, config);
export const putChatHistoryList = (path, updateData, config) => chatHistoryList.put(path, updateData, config);
export const putChatConsultRoomList = (path, config) => chatConsultRoomList.put(path, config);
export const putChatUpdateRoomRead = (path, updateData, config) => chatUpdateRoomRead.put(path, updateData, config);

export const putChatRoomCreate = (path, updateData, config) => chatRoomCreate.put(path, updateData, config);
export const putChatRoomRecordDownload = (path, updateData, config) => chatRoomRecordDownload.put(path, updateData, config);
export const putAiSearchBarResults = (path, updateData, config) => putAiSearchBar.put(path, updateData, config);
export const putCoinFreeConvert = (path, updateData, config) => coinFreeConvert.put(path, updateData, config);
export const putRedeemConvert = (path, updateData, config) => redeemConvert.put(path, updateData, config);
export const putLinePayHandlePayment = (path, updateData, config) => linePayHandlePayment.put(path, updateData, config);
export const putLoadTranslatorResult = (path, updateData, config) => loadTranslatorResult.put(path, updateData, config);
export const putSaveTranslatorResult = (path, updateData, config) => saveTranslatorResult.put(path, updateData, config);
export const putLoadSideEffectAmount = (path, updateData, config) => loadSideEffectAmount.put(path, updateData, config);
export const putLoadSideEffectCharts = (path, updateData, config) => loadSideEffectCharts.put(path, updateData, config);
export const putLoadGoldKnowLedge = (path, config) => loadGoldKnowLedge.put(path, config);
export const putEditUserAccount = (path, updateData, config) => userEditAccountProfile.put(path, updateData, config);
export const putLineFastLogin = (path, updateData) => lineFastLogin.put(path, updateData);
export const putLineKeepLogin = (path, updateData) => lineKeepAutoLogin.put(path, updateData);
export const putLoadVendorBindProfile = (path, updateData) => loadVendorBindProfile.put(path, updateData);
export const putLoadVendorProfile = (path, updateData) => loadVendorProfile.put(path, updateData);
export const putLoadCourseList = (path, updateData, config) => courseList.put(path, updateData, config);
export const putLoadCourseDetail = (path, updateData, config) => courseDetail.put(path, updateData, config);
export const putLoadCourseUnitContent = (path, updateData, config) => courseLoadUnitContent.put(path, updateData, config);
export const putLoadCourseEvaluate = (path, updateData, config) => courseLoadEvaluate.put(path, updateData, config);
export const putLoadCourseUserEvaluateDetail = (path, updateData, config) => courseUserEvaluateDetail.put(path, updateData, config);
export const putEditCourseEvaluate = (path, updateData, config) => courseControlEvaluate.put(path, updateData, config);
export const putReceiveTrailSubscribe = (path, updateData, config) => receiveTrailSubscribe.put(path, updateData, config);
export const putUpdateNewsRead = (path, updateData, config) => userUpdateNewsRead.put(path, updateData, config);
// export const putResetNewsRead = (path, updateData, config) => userResetNewsRead.put(path, updateData, config);
export const putUserLoadNews = (path, config) => userLoadLatestNews.put(path, config);
export const putUserLoadAnalysis = (path, updateData, config) => userLoadAnalysis.put(path, updateData, config);
export const putUserEvaluateAnalysis = (path, updateData, config) => userEvaluateAnalysis.put(path, updateData, config);
export const putUpdateChatHistoryList = (path, updateData, config) => chatUpdateHistoryList.put(path, updateData, config);
export const putLectureList = (path, updateData, config) => lectureList.put(path, updateData, config);
export const putLectureDetail = (path, updateData, config) => lectureDetail.put(path, updateData, config);
export const putRedeemValidCheck = (path, updateData, config) => redeemValidCheck.put(path, updateData, config);
export const putLoadUserFeedback = (path, updateData, config) => loadUserFeedback.put(path, updateData, config);
export const putLineOfficialBundle = (path, updateData, config) => lineOfficialBundle.put(path, updateData, config);
export const putDjangoAllTypeMember = (path, config) => checkAllAuthMember.put(path, config);
export const putDjangoMemberFindPassword = (path, updateData, config) => checkAuthMemberFindPassword.put(path, updateData, config);
export const putLoadEproFormList = (path, updateData, config) => loadEproFormList.put(path, updateData, config);
export const putLoadEproFormDetail = (path, updateData, config) => loadEproFormDetail.put(path, updateData, config);
export const putCheckEproRecordDate = (path, updateData, config) => checkEproRecordDate.put(path, updateData, config);
export const putEproFormJoinCheck = (path, updateData, config) => eproFormJoinCheck.put(path, updateData, config);
export const putLoadDietRecognize = (path, updateData, config) => loadDietRecognize.put(path, updateData, config);
export const putVendorBindCheck = (path, updateData, config) => vendorBindCheck.put(path, updateData, config);
export const putSendVerifiedMail = (path, updateData, config) => sendVerifiedConfirm.put(path, updateData, config);
export const putUnsubscribeMail = (path, updateData, config) => unsubscribeMail.put(path, updateData, config);
export const putHealthCheckStatus = (path, config) => healthCheckStatus.put(path, config);
export const putHealthCheckProfile = (path, config) => healthCheckProfile.put(path, config);
export const putChronicBloodList = (path, updateData, config) => chronicBloodList.put(path, updateData, config);

// Delete Methods
export const deleteSessionKeepLogin = (path) => cleanSessionKeepLogin.delete(path);
export const deleteBookmark = (path, data) => userAddBookmark.delete(path, data);
export const deleteResumeBookmark = (path, data) => userResumeBookmark.delete(path, data);
export const deleteDrugBookmark = (path, data) => userDrugBookmark.delete(path, data);
export const deleteQaBookmark = (path, data) => userQaBookmark.delete(path, data);
// export const deleteScoopBookmark = (path, data) => userScoopBookmark.delete(path, data);
// export const deleteTeamBookmark = (path, data) => userTeamBookmark.delete(path, data);
export const deleteAgree = (path, data) => userAgree.delete(path, data);
export const deleteLike = (path, data) => userLike.delete(path, data);
export const deleteResumeAgree = (path, data) => userResumeAgree.delete(path, data);
export const deleteResumeLike = (path, data) => userResumeLike.delete(path, data);
export const deleteQaAgree = (path, data) => userQaAgree.delete(path, data);
export const deleteQaLike = (path, data) => userQaLike.delete(path, data);
// export const deleteScoopAgree = (path, data) => userScoopAgree.delete(path, data);
// export const deleteScoopLike = (path, data) => userScoopLike.delete(path, data);
export const deleteFollow = (path, data) => userFollow.delete(path, data);
export const deleteUserResume = (path, data) => createUserResume.delete(path, data);
export const deleteResumeCureDrug = (path, data) => resumeCureDrug.delete(path, data);
export const deleteUserBless = (path, data) => controlBless.delete(path, data);
export const deleteQaKillReply = (path, data) => deleteQaReply.delete(path, data);
export const deleteQaKillAsk = (path, data) => deleteQaAsk.delete(path, data);
export const deleteExistNotify = (path, data) => controlNewNotify.delete(path, data);
export const deleteAllNotifyRead = (path, data) => clearAllNotifyRead.delete(path, data);
export const deleteSideEffectRecord = (path, data) => killSideEffectRecord.delete(path, data);
export const deleteTranslatorResult = (path, data) => saveTranslatorResult.delete(path, data);
export const removeAvatarUpload = (path, config) => userAvatarUpload.get(path, config);
export const deleteCourseEvaluate = (path, data) => courseControlEvaluate.delete(path, data);
export const deleteEproFormJoin = (path, data) => eproFormJoinControl.delete(path, data);
